import type { EpisodeOfCareProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"

export const getRecordedDiagnosisCode = (
  episodeOfCareProgressNoteData: EpisodeOfCareProgressNoteData,
  diagnosisCode: string,
): string | null => (episodeOfCareProgressNoteData.episodeOfCareId ? diagnosisCode.trim() || null : null)
